<template>
  <div class="dropdown-event" v-click-outside="closeContent">
    <button
      class="dropdown-event__header"
      :class="{ open: isContentOpen }"
      @click="toggleDropdown"
      ref="dropdownEventButton"
    >
      <icon name="arrow-down" />
    </button>
    <div v-if="isContentOpen" class="dropdown-event__content" :style="coords">
      <button
        v-for="option in options"
        :key="option['ТипЦены']"
        @click="chooseType(option)"
        class="dropdown-event__content-item"
        :class="{
          _active: JSON.stringify(currentType) === JSON.stringify(option)
        }"
      >
        {{ locale === "en" ? option.title_eng : option.title_rus }}
      </button>
    </div>
  </div>
</template>

<script>
import { i18n } from "@v2/shared/config";

export default {
  props: {
    value: {
      type: Object
    },

    options: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    coords() {
      return `bottom:${this.styleElHeight}px;`;
    },
    locale() {
      return i18n.locale;
    }
  },

  data() {
    return {
      isContentOpen: false,
      currentType: this.value,
      styleElHeight: 0
    };
  },

  methods: {
    toggleDropdown() {
      this.isContentOpen = !this.isContentOpen;
      this.styleElHeight = this.isContentOpen
        ? this.$refs.dropdownEventButton.offsetHeight
        : 0;
    },

    closeContent() {
      this.isContentOpen = false;
    },

    chooseType(type) {
      this.currentType = type;
      this.closeContent();
    }
  },

  watch: {
    value(value) {
      this.currentType = value;
    },

    currentType(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";

.dropdown-event {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  position: relative;

  &__header {
    @include button-clean();

    display: flex;
    align-items: center;

    width: 100%;
    height: 100%;

    font-size: 14px;
    font-weight: 500;

    line-height: 1.43;

    color: #6d7179;

    @include respond-down(md) {
      font-size: 12px;
    }

    .svg-icon {
      width: 11px;
      height: 7px;

      margin: auto;

      flex-shrink: 0;

      filter: grayscale(1);
    }

    &.open {
      transform: scale(1, -1);
    }
  }

  &__content {
    width: 230px;
    right: -100px;
    border-radius: 2px;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    overflow: hidden;
    position: absolute;

    z-index: 1;

    &-item {
      @include button-clean();

      display: block;

      width: 100%;

      padding: 10px 16px;

      font-size: 13px;
      line-height: 1.54;
      color: #000;

      text-align: left;

      &._active,
      &:hover {
        background: #009ee3;
        color: #fff;
      }
    }
  }
}
</style>
